import { useCustomSnackbar } from '@procureai/ui-mui';
import { useEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import { Action, Target, useTrackInteraction } from '~/hooks/useTrackInteraction/useTrackInteraction';

const debounceTimeoutMs = 3000;

export const SearchHubbleTracking = () => {
  const { addMiddlewares } = useInstantSearch();
  const { enqueueErrorSnackbar } = useCustomSnackbar();
  const track = useTrackInteraction();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const sendEventDebounced = (query: string) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        track(Target.SEARCH, Action.SEARCHED_QUERY, {
          query,
        });
      }, debounceTimeoutMs);
    };

    return addMiddlewares(() => {
      return {
        onStateChange({ uiState }) {
          const query = uiState[''].query;
          if (query) {
            sendEventDebounced(query);
          }
        },
      };
    });
  }, [addMiddlewares, enqueueErrorSnackbar, track]);

  return null;
};
